import { dataUserSearch } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSearch = /*#__PURE__*/createIcon(dataUserSearch)
export default IconUserSearch
